/* eslint-disable prettier/prettier */
// library imports
import * as React from "react";
import {
  Grid,
  Link,
  InputLabel,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import ReactQuill from "react-quill";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useHistory } from "react-router-dom";
import UnsavedChangesModal from "../modals/UnsavedChangesModal";
import { useFlash } from "../FlashContext";
interface Props {
  name: String;
  setName: any;
  subtext: String;
  setSubText: any;
  blocks: any;
  setBlocks: any;
  handleBlockRemoval: any;
  handleTemplateSave: any;
  disableSave: boolean;
  published: boolean;
  archived: boolean;
  editState: boolean;
}
// constants
const TITLE_MAX_LENGTH = 100;
const SUBTEXT_MAX_LENGTH = 500;

const NoteTemplateForm: React.FC<Props> = (props: any) => {
  const [showTemplateModal, setShowTemplateModal] =
    React.useState<boolean>(false);
  const history = useHistory();
  const { showToast } = useFlash();
  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState<boolean>(false);

 const onEditorStateChange = (data: string, block: any) => {
    const updatedBlocks = props.blocks.map((b) =>
      b.order === block.order ? { ...b, note: data } : b
    );
    props.setBlocks(orderedBLocks(updatedBlocks));
    setHasUnsavedChanges(true);
  };

  const handleBlockAddition = () => {
    const highestOrder = Math.max(...props.blocks.map((block) => block.order));
    props.setBlocks(
      orderedBLocks([
        ...props.blocks,
        { id: "", order: highestOrder + 1, note: "" },
      ])
    );
  };

 const orderedBLocks = (newBlocks: any[]) => {
    return [...newBlocks].sort((a, b) => a.order - b.order);
  };

  const isBlank = (str) => {
    return !str || str === undefined || str.trim() === "";
  };
  const setErrorFlash = (message) => {
    showToast({
      title: "Validation Error",
      text: message,
      type: "error",
    });
  };

  const validateFields = () => {
    if (isBlank(props.name)) {
      setErrorFlash("Title is required.");
      return false;
    }
    return true;
  };

  type InputChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;

  const handleLimitedInput =
    (
      setValue: (val: string) => void,
      maxLength: number
    ): InputChangeHandler =>
    (event) => {
      const next = event.target.value;

      if (next.length <= maxLength) {
        setValue(next);
      }
    };
    
  const handleChange = () => {
    if(validateFields()){
      setHasUnsavedChanges(false);
      props.handleTemplateSave()
    }
  }

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      className="wrapper"
    >
      <UnsavedChangesModal unsavedChanges={hasUnsavedChanges} />
      <Grid
        item
        xs={12}
        id="provider-action-report"
        className="patient-edit-container patient-edit-form provider-action-report new-questionnaire-container"
      >
        <Grid container>
          <Grid
            className="patient-edit-header"
            container
            justifyContent="space-between"
          >
            <Grid item xs={4}>
              <p className="secondary-label" style={{ marginLeft: "0px" }}>
                {props.editState ? "Edit/View Template" : "Add New Template"}
              </p>
            </Grid>

            <Grid item xs={6} className="q-btn-container">
              <Link
                style={{ marginRight: "16px" }}
                
                onClick={() => history.push('/templates-list')}
              >
                Back to List
              </Link>
              {!props.published && !props.archived && (
                <Button
                  className="orange-btn"
                  onClick={handleChange}
                  style={{
                    height: "40px",
                    marginRight: "16px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                  disabled={props.published || props.archived}
                >
                  Save Draft
                </Button>
              )}
            </Grid>
          </Grid>
          <Grid container>
            {/* column 1 */}
            <Grid item xs={3}>
              <Grid container className="form-container">
                <Grid
                  item
                  xs={12}
                  className="patient-info-left-container form-left-container"
                  style={{
                    marginLeft: "30px",
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="name"
                        className="field-label"
                        style={{ color: "#000000", fontWeight: 700 }}
                      >
                        Title*
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="name"
                        size="small"
                        value={props.name}
                        className="the-field"
                        required
                        variant="outlined"
                        disabled={props.published || props.archived}
                        placeholder="Enter Name"
                        inputProps={{ maxLength: TITLE_MAX_LENGTH }}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                        ) => {
                          const { value } = event.target;
                          if (value.length > TITLE_MAX_LENGTH) return;
                          props.setName(value);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="name"
                        className="field-label"
                        style={{ color: "#000000", fontWeight: 700 }}
                      >
                        Subtext
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} className="field-container">
                      <TextField
                        id="subtext"
                        size="small"
                        value={props.subtext}
                        className="the-field"
                        required
                        variant="outlined"
                        disabled={props.published || props.archived}
                        placeholder="Enter Subtext"
                        inputProps={{ maxLength: SUBTEXT_MAX_LENGTH }}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                        ) => {
                          const { value } = event.target;
                          if (value.length > SUBTEXT_MAX_LENGTH) return;
                          props.setSubText(value);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Typography style={{paddingTop: "2rem"}}>
                      *Required
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* column 2 */}
            <Grid item xs={5} className="right-column">
            {props.blocks?.map((block, index) => {
                return (
                  <Grid key={index} container item xs={12}>
                    <Grid item xs={12}>
                      <InputLabel className="field-label">
                        Template Block #{index + 1}
                        {index != 0 && (
                          <Link>
                            <DeleteIcon
                              style={{
                                fontSize: 24,
                                color: "#c1b7b3",
                                display: "inline-block",
                                cursor: "pointer",
                                marginLeft: 10,
                                position: "relative",
                                bottom: -4,
                              }}
                              onClick={() => {
                                props.handleBlockRemoval(block);
                              }}
                            />
                          </Link>
                        )}
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                      <ReactQuill
                        theme="snow"
                        value={block.note}
                        onChange={(value) => {
                          setHasUnsavedChanges(true)
                          onEditorStateChange(value, block)
                        }}
                        modules={{
                          clipboard: {
                            matchVisual: false,
                          },
                        }}
                        preserveWhitespace
                        readOnly={props.published || props.archived}
                      />
                    </Grid>
                  </Grid>
                );
              })}
              {(!props.published && !props.archived) && <Grid container item xs={12}>
                <Link
                  className="action-link"
                  style={{ cursor: "pointer" }}
                  onClick={handleBlockAddition}
                >
                  <AddIcon className="plus-icon" />{" "}
                  <span className="app-user-text">Add Template Block</span>
                </Link>
              </Grid>}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NoteTemplateForm;
